import React from "react";

import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import PhoneInput, { Country } from "react-phone-number-input";

import { ErrorMessage, RequiredMark } from "@components/inputs/shared";
import {
	getDefaultCountryCodeForTheme,
	isPhoneValidOnRegistration,
} from "@utils";
import classnames from "classnames";

export default function RegistrationPhone(props: {
	required?: boolean;
	labelClassName?: string;
}) {
	const translationHook = useTranslation("registration");
	const {
		formState: { errors },
		getValues,
	} = useFormContext();

	const error = errors?.["mobilePhone"];

	const defaultCountryCode = getDefaultCountryCodeForTheme();

	return (
		<div className="form__field u-mar--bottom--reset">
			<label htmlFor="mobNumber" className="label label--strong">
				{translationHook.t<string>("MOBILE_PHONE_LABEL")}
				<RequiredMark required={props.required} />
			</label>

			<ErrorMessage name="mobilePhone" />
			<Controller
				name="mobilePhone"
				rules={{
					required: {
						value: props?.required || false,
						message: "COMMON.REQUIRED_FIELD",
					},
					validate: {
						isPhoneValidOnRegistration: async (e) => {
							const valid = await isPhoneValidOnRegistration(e);
							return valid
								? true
								: "COMMON.INVALID_PHONE";
						},
					},
				}}
				render={({ field }) => {
					return (
						<PhoneInput
							id="mobNumber"
							className={classnames({
								"PhoneInput--error": error != undefined,
							})}
							{...field}
							international
							defaultCountry={defaultCountryCode as Country}
							onChange={field.onChange}
							value={getValues("mobilePhone")}
						/>
					);
				}}
			/>
		</div>
	);
}
